<script setup lang="ts">
import { formatPrice } from '../../utils/price'
import PaymentStatus from './PaymentStatus.vue'

export type HistoryEvent = {
  message: string
  timestamp: string
  status: string
}

type Payment = {
  id: number
  creator: { id: number; name: string; email: string }
  payment_date: Date | string
  accepted_at: Date | string
  payment_error_id: number
  creator_cost: { amount: number; currency: string }
  client_cost: { amount: number; currency: string }
  show_creator: boolean
  status?: string
  able_to_be_accepted: boolean
  payment_history: HistoryEvent[]
}

defineProps<{ payments: Payment[] }>()
defineEmits<{ (e: 'download', payment: Payment): void }>()

function formatDate(date: string | Date): string {
  return new Date(date).toISOString().slice(0, 10)
}
</script>
<template>
  <div class="payments-table">
    <div class="row header">
      <div>Date</div>
      <div>ID</div>
      <div>Amount</div>
      <div>Status</div>
      <div>Download</div>
    </div>

    <template v-for="payment in payments" :key="payment.id">
      <div class="row">
        <div>{{ formatDate(payment.payment_date) }}</div>
        <div>{{ payment.id }}</div>
        <div>{{ formatPrice(payment.creator_cost.amount, payment.creator_cost.currency) }}</div>
        <div>
          <PaymentStatus :invoice-id="payment.id" :status="payment.status" :history-events="payment.payment_history ?? []" />
        </div>
        <div>
          <button v-if="payment.show_creator" class="pdf-btn" @click="$emit('download', payment)">PDF</button>
        </div>
      </div></template
    >

    <p v-if="!payments?.length" class="empty">No payments found.</p>
  </div>
</template>
<style scoped>
.payments-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 1rem;
  font-size: 0.9rem;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}

.row > div {
  flex: 1;
  text-align: left;
  margin: 0;
}

.header {
  font-weight: 600;
  font-size: 24px;
  border-bottom: 2px solid #ccc;
  color: #222;
}

.pdf-btn {
  background: none;
  border: none;
  color: #2563eb;
  font-size: 0.85rem;
  cursor: pointer;
  padding: 0;
}

.pdf-btn:hover {
  text-decoration: underline;
}

.empty {
  text-align: center;
  color: #999;
  margin-top: 1rem;
}
</style>
